export default __webpack_public_path__ + "static/media/kiosk-logo-typo.7bcf1c86.svg";